export enum CapacityLevelType {
  'annual' = 'annual',
  'monthly' = 'monthly',
  'daily' = 'daily',
  'total' = 'total',
}
